import React from 'react';
import Column from '../../column';
import Title from './title';
import Wrapper from './wrapper';
import ListItem from './list-item';

const List = ({
  // id,
  columnWidth,
  order,
  card,
  title,
  variant,
  items,
  offset,
}) => (
  <Column
    columnWidth={columnWidth}
    card={card}
    order={order}
    offset={offset}
  >
    {title && <Title $variant={variant}>{title}</Title>}
    <Wrapper $variant={variant}>
      {(items || []).map(({
        id,
        ...item
      }) => (
        <ListItem
          key={id}
          $variant={variant}
          {...item}
        />
      ))}
    </Wrapper>
  </Column>
);

export default List;
